export default __webpack_public_path__ + "static/media/plataforma.ec2f6997.png";